import React, { useState, useEffect } from "react";
import { StarFilled } from "@ant-design/icons";
import NewProduct from "../home/NewProduct";
import BestSeller from "../home/BestSeller";
import { Carousel, Row, Col, Button } from "react-bootstrap";
import ReactTypingEffect from "react-typing-effect";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./css/Home.css";
import { Link } from "react-router-dom"; // นำเข้า Link จาก react-router-dom
import MenubarUserHomeNew from "../layouts/MenubarUserHomeNew";
import axios from "axios";
// import MenubarUserHomeNew from "../page/MenuUserHGome/MenubarUserHomeNew";

import DonatePok from "./imageDonate/1.jpg";

import firstSlideImage from "./images/1.png";
import secondSlideImage from "./images/2.png";
import thirdSlideImage from "./images/3.png";
import fourthSlideImage from "./images/4.png";
import fifthSlideImage from "./images/5.png";
import MUVITA1 from "./images/MUVITA1.png";
import MUVITA2 from "./images/MUVITA2.png";
import PANAPRO from "./images/Panapro.png";
import UNIQUE from "./images/unique.jpg";
import UNIQUE1 from "./images/unique1.png";
import YEC from "./images/yoouen2.png";
import DreamLabImg from "./images/DreamLab.jpg";
import LeDreamImg from "./images/LeDream.jpg";
import by from "./images/45221.514.png";

import lineImage from "./image/line.png";
import logo from "./auth/logo/logo.png"; // ใส่ path ของโลโก้ที่นี่
import Footer from "../layouts/Footer";

import u1SlideImage from "./imageUnique/1.jpg";
import u2SlideImage from "./imageUnique/2.jpg";
import u3SlideImage from "./imageUnique/3.jpg";
import u4SlideImage from "./imageUnique/4.jpg";
import u5SlideImage from "./imageUnique/5.jpg";

import y1SlideImage from "./imageYooEnCare/1.jpg";
import y2SlideImage from "./imageYooEnCare/2.jpg";
import y3SlideImage from "./imageYooEnCare/3.jpg";
import y4SlideImage from "./imageYooEnCare/4.jpg";
import y5SlideImage from "./imageYooEnCare/5.jpg";

import "../page/Home.css";
import HotUniqare from "../home/HotUniqare";
import CategoryProduct from "../home/CategoryProduct";
import YooEnCare from "../home/YooEnCare";
import LeDream from "../home/LeDream";
import MenubarUserHomeProduct from "../layouts/MenubarUserHomeProduct";
import MenubarUserHome from "../layouts/MenubarUserHome";
import AllProduct from "../home/AllProduct";

const Home = () => {
  const navigate = useNavigate(); // ใช้ useNavigate เพื่อการนำทาง

  const handleButtonClick = () => {
    navigate("/contact-shop"); // นำทางไปยัง component1 เมื่อคลิกปุ่ม
  };

  const handleImageClick = (productId, event) => {
    event.stopPropagation(); // หยุดการส่งต่อเหตุการณ์
    console.log("Clicked productId:", productId);
    if (productId) {
      navigate(`/product/${productId}`);
    } else {
      console.log("ไม่มีสินค้าเชื่อมโยงกับรูปภาพ");
    }
  };

  const handleNavigateToShop = (category, categoryType) => {
    navigate(`/shop-origi?category=${category}&categoryType=${categoryType}`);
  };

  const [carouselImages, setCarouselImages] = useState([]);
  useEffect(() => {
    const fetchCarouselImages = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API + "/admin/getimages-carousel",
        );
        // console.log("Response data:", response.data);
        const selectedImages = response.data.filter(
          (image) => image.isSelected,
        ); // กรองเฉพาะรูปภาพที่มี isSelected: true
        setCarouselImages(selectedImages);
      } catch (error) {
        console.error("Error fetching carousel images:", error);
      }
    };

    fetchCarouselImages();
  }, []);

  const [bannerImages, setBannerImages] = useState([]);
  useEffect(() => {
    const fetchBannerImages = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API + "/admin/getimages-banner",
        );
        setBannerImages(response.data);
      } catch (error) {
        console.error("Error fetching banner images:", error);
      }
    };

    fetchBannerImages();
  }, []);

  return (
    <>
      <div className="container mt-0">
        <div className="row mt-1 ">
          <div className="col-md-12 mt-5">
            <Carousel interval={2000}>
              {carouselImages.map((image) => (
                <Carousel.Item
                  key={image._id}
                  onClick={(event) => handleImageClick(image.product, event)}
                >
                  <img
                    className="d-block w-100"
                    src={image.url}
                    alt={image.alt}
                    style={{ cursor: "pointer" }}
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </div>

        <div className="container mt-5 d-flex justify-content-center mt-0 ">
          <div className="col-md-12 mb-3 ">
            <MenubarUserHomeNew />
          </div>
        </div>

        <div className="mt-5">
          <div className="custom-headingHotProduct-container mb-3"></div>
          <BestSeller />
        </div>

        <div className="mt-5 mb-1">
          <div className="col-12 custom-headingNewProduct-container mb-3"></div>
          <NewProduct />
        </div>

        <div className="container d-flex flex-column justify-content-center align-items-center"></div>

        <div className="row d-flex justify-content-center align-items-center">
          {bannerImages.map((img) => (
            <div
              key={img._id}
              className="col-10 col-md-11 mx-auto d-flex justify-content-center align-items-center"
              onClick={() => {
                if (img.link) {
                  // ถ้ามี link ให้เปิดลิงก์ภายนอก
                  window.open(img.link, "_blank");
                } else if (img.product?._id) {
                  navigate(`/product/${img.product._id}`);
                } else if (img.category?._id) {
                  navigate(
                    `/shop?categoryId=${img.category._id}&categoryType=category`,
                  );
                } else if (img.categoryservice?._id) {
                  navigate(
                    `/shop?categoryId=${img.categoryservice._id}&categoryType=categoryservice`,
                  );
                }
              }}
            >
              <img
                className="d-block w-100 mt-3"
                src={img.url}
                alt={img.alt}
                style={{
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
              />
            </div>
          ))}
        </div>

        <div>
          <div className="row mt-3 d-flex justify-content-center align-items-center">
            <div className="col-6 col-md-5">
              <div
                className="custom-box"
                style={{
                  backgroundImage: `url(${require("./img/1.png")})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "#ffffff",
                }}
              >
                {/* <p className="custom-text">https://www.360healthyshop.com/</p>
                <p className="custom-text">โฆษณา</p>
                <p className="custom-text">ขนาดภาพ 600x400 Pixel</p>
                <p className="custom-text">โทร: 084-1652479</p> */}
              </div>
            </div>
            <div className="col-6 col-md-5">
              <div
                className="custom-box"
                style={{
                  backgroundImage: `url(${require("./img/4.png")})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "#ffffff",
                }}
              >
                {/* <p className="custom-text">https://www.360healthyshop.com/</p>
            <p className="custom-text">โฆษณา</p>
            <p className="custom-text">ขนาดภาพ 600x400 Pixel</p>
            <p className="custom-text">โทร: 084-1652479</p> */}
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-4 col-md-4">
              <div
                className="custom-box"
                style={{
                  backgroundImage: `url(${require("./img/2.png")})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "#ffffff",
                }}
              >
                {/* <p className="custom-text">https://www.360healthyshop.com/</p>
                <p className="custom-text">โฆษณา</p>
                <p className="custom-text">ขนาดภาพ 400x200 Pixel</p>
                <p className="custom-text">โทร: 084-1652479</p> */}
              </div>
            </div>
            <div className="col-4 col-md-4">
              <div
                className="custom-box"
                style={{
                  backgroundImage: `url(${require("./img/3.png")})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "#ffffff",
                }}
              >
                {/* <p className="custom-text">https://www.360healthyshop.com/</p>
            <p className="custom-text">โฆษณา</p>
            <p className="custom-text">ขนาดภาพ 400x200 Pixel</p>
            <p className="custom-text">โทร: 084-1652479</p> */}
              </div>
            </div>
            <div className="col-4 col-md-4">
              <div
                className="custom-box"
                style={{
                  backgroundImage: `url(${require("./img/6.png")})`, // ใส่ path รูปภาพ
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  color: "#ffffff", // เปลี่ยนสีตัวอักษร
                }}
              >
                {/* <p className="custom-text">https://www.360healthyshop.com/</p>
            <p className="custom-text">โฆษณา</p>
            <p className="custom-text">ขนาดภาพ 600x400 Pixel</p>
            <p className="custom-text">โทร: 084-1652479</p> */}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5 mb-1">
          <Link to="/shop">
            <div className="col-12 custom-headingAllProduct-container ">
              <div className="custom-heading blinking-boxss mt-1"></div>
            </div>
          </Link>

          <AllProduct />
        </div>

        <div className="row mt-5">
          <div
            className="col-12 col-md-6 d-flex justify-content-center align-items-center mx-auto"
            style={{ marginRight: "50px" }}
          >
            <div className="ratio ratio-16x9">
              <iframe
                className="embed-responsive-item"
                src="https://www.youtube.com/embed/2F24ztMGPjE?si=jXAg5RehB5NXykEc"
                title="YouTube video player"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="text-center mt-5">
            <button
              className="btn me-3"
              onClick={handleButtonClick}
              style={{ backgroundColor: "#FF70A6", color: "#fff" }}
            >
              ช่องทางการสั่งซื้อ
            </button>
          </div>
        </div>

        <div className="review-section">
          <div className="review-header">
            <StarFilled style={{ fontSize: 24, color: "#FF70A6" }} />
            <h4 className="review-title">รีวิวจากผู้ใช้งาน</h4>
          </div>

          <Carousel indicators={true} controls={true} interval={3000}>
            <Carousel.Item>
              <div className="review-grid">
                <img
                  className="review-img"
                  src={firstSlideImage}
                  alt="review 1"
                />
                <img
                  className="review-img"
                  src={secondSlideImage}
                  alt="review 2"
                />
                <img
                  className="review-img"
                  src={thirdSlideImage}
                  alt="review 3"
                />
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="review-grid">
                <img
                  className="review-img"
                  src={fourthSlideImage}
                  alt="review 4"
                />
                <img
                  className="review-img"
                  src={fifthSlideImage}
                  alt="review 5"
                />
                <img
                  className="review-img"
                  src={firstSlideImage}
                  alt="review 6"
                />
              </div>
            </Carousel.Item>
          </Carousel>
        </div>

        <div className="mt-5 mb-1">
          <Link to="/donate">
            <div className="col-12 custom-headingDonate-container"></div>
            {/* <div className="text-center mt-2 mb-5">
                  <img
                    src={DonatePok}
                    alt="Donation"
                    style={{ width: "400px", height: "auto" }} 
                  />
                </div> */}
          </Link>

          {/* <NewProduct /> */}
        </div>

        <div className="row justify-content-center align-items-center mt-2 ">
          <div className="col-12 col-md-8 mt-5 mb-5 d-flex flex-column flex-md-row align-items-center text-center text-md-left">
            {/* <img
            src={logo}
            alt="Logo"
            className="img-fluid mb-3 mb-md-0 responsive-logo" 
            style={{ maxWidth: "300px" }}
          /> */}
            <div
              className="d-flex flex-column align-items-center justify-content-center"
              style={{ width: "100%" }}
            >
              <ReactTypingEffect
                text={["360 healthyshop จำหน่ายผลิตภัณฑ์เพื่อสุขภาพ"]}
                speed={100}
                eraseSpeed={50}
                eraseDelay={1000}
                typingDelay={500}
                style={{ color: "#FF1493" }}
              />
              <br />
              <br />
              <p style={{ textAlign: "justify", padding: "0 20px" }}>
                360healthyshop จำหน่ายผลิตภัณฑ์เพื่อสุขภาพ
                ผลิตภัณฑ์ที่ช่วยปรับสมดุลร่างกายทางกายภาพ
                เคล็ดลับการมีสุขภาพที่ดี ความปลอดภัยต่อผู้บริโภคเป็นสิ่งสำคัญ
                เราเลือกผลิตภัณฑ์ทุกชิ้นมีการผ่านการรับรองจากองค์กรอาหารและยา
                (อย.) และได้รับรับรองมาตราฐาน GMP
                เพื่อตอบโจทย์ปัญหาได้ตรงจุดและเข้าถึงผู้บริโภคมากที่สุด
              </p>
            </div>
          </div>
        </div>

        {/* <Footer /> */}
      </div>
    </>
  );
};

export default Home;
